<template>
  <div id="document-sidebar-foldertreeitem">
    <div
      v-for="(folder, index) in folders"
      class="flex flex-col pl-6 p-0"
      :key="index"
    >
      <tree-template
        :folder="folder"
        :switchOpenMethod="toggleSwitchOpen"
        :selectedMethod="toggleTreeSelect"
        :isSelected="isSelected"
      >
        <template #child>
          <folder-tree-item :folders="folder.folders" :validate="validate"/>
        </template>
      </tree-template>
    </div>
  </div>
</template>

<script>
import TreeTemplate from "../../../tree/DocumentFolderTemplate"
import FolderTreeItem from "./DocumentMoveDialogTreeItem"
import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  name: "FolderTreeItem",
  components: {
    TreeTemplate,
    FolderTreeItem,
  },
  props: {
    folders: { type: Array },
    validate: { type: Function }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "selectedMoveDialogFolderPath", "documentRootPath"
    ])
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "fetchTreeFolders"
    ]),
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_FOLDERS_IS_OPEN",
      "SET_SHOW_FOLDER_LIST",
      "SET_SELECTED_MOVE_DIAROG_FOLDER",
      "SET_DOCUMENT_NEW_PATH"
    ]),
    async toggleSwitchOpen (folder) {
      this.SET_FOLDERS_IS_OPEN(folder)
      await this.fetchTreeFolders(folder)
    },
    async toggleTreeSelect (folder) {
      try {
        await this.fetchTreeFolders(folder)
        const newPath = `${folder.path.replace(this.documentRootPath, "")}/`
        this.SET_DOCUMENT_NEW_PATH(newPath)
        this.SET_SELECTED_MOVE_DIAROG_FOLDER(folder.path)
        if(!("validate" in this)) return;
        this.validate(newPath)
      } catch (error) {
        console.error(error)
        throw error;
      }
    },
    isSelected (path) {
      return this.selectedMoveDialogFolderPath === path
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#document-sidebar-foldertreeitem {
  .document-tree-item-selected {
    background: $aisea-pure-white;
    color: $aisea-blue;
  }
}
</style>